import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export function useLocalizedCollator() {
  const { i18n } = useTranslation()

  return useMemo(() => {
    return new Intl.Collator(i18n.language)
  }, [i18n.language])
}
